export default __webpack_public_path__ + "static/media/Grips of Insanity.5d8c46b0.jpg";